import { render, staticRenderFns } from "./Agendor.container.vue?vue&type=template&id=8bf5c632&"
import script from "./Agendor.container.vue?vue&type=script&lang=ts&"
export * from "./Agendor.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports